/* Nevel geurcheck: leest een ingrediëntenlijst (INCI) en wijst geurstoffen aan.
   Alles gebeurt in de browser; er wordt niets verstuurd of bewaard. */
(function () {
	var root = document.getElementById('nv-geurcheck');
	if (!root) return;

	// Toegevoegde geur.
	var PARFUM = ['parfum', 'fragrance', 'perfume', 'aroma'];

	// Geurstoffen die boven een bepaalde hoeveelheid op het etiket moeten (EU), met de meest voorkomende.
	// 'ook' = de stof heeft ook een andere functie, dus niet per se als geur toegevoegd.
	var STOFFEN = [
		['linalool'], ['limonene'], ['citral'], ['geraniol'], ['citronellol'], ['eugenol'], ['isoeugenol'],
		['coumarin'], ['farnesol'], ['cinnamal'], ['cinnamyl alcohol'], ['amyl cinnamal'], ['amylcinnamyl alcohol'],
		['hexyl cinnamal'], ['hydroxycitronellal'], ['anise alcohol'], ['benzyl cinnamate'], ['methyl 2-octynoate'],
		['alpha-isomethyl ionone'], ['evernia prunastri'], ['evernia furfuracea'],
		['benzyl alcohol', 'ook'], ['benzyl benzoate', 'ook'], ['benzyl salicylate', 'ook'],
		['linalyl acetate'], ['geranyl acetate'], ['eugenyl acetate'], ['isoeugenyl acetate'], ['amyl salicylate'],
		['anethole'], ['benzaldehyde'], ['carvone'], ['caryophyllene'], ['damascone'], ['acetyl cedrene'],
		['hexadecanolactone'], ['hexamethylindanopyran'], ['methyl salicylate'], ['pinene'], ['sclareol'],
		['terpineol'], ['terpinene'], ['terpinolene'], ['tetramethyl acetyloctahydronaphthalenes'],
		['trimethylbenzenepropanol'], ['dimethylbenzyl carbinyl acetate'],
		['camphor', 'ook'], ['menthol', 'ook'], ['vanillin', 'ook']
	];

	// Planten waarvan de olie bijna altijd een etherische (geurende) olie is.
	var GENERA = ['lavandula', 'citrus', 'rosa', 'mentha', 'eucalyptus', 'melaleuca', 'rosmarinus', 'salvia',
		'pelargonium', 'cananga', 'santalum', 'cymbopogon', 'juniperus', 'pogostemon', 'cedrus', 'boswellia',
		'commiphora', 'vetiveria', 'chrysopogon', 'origanum', 'thymus', 'cupressus', 'pinus', 'abies', 'anthemis',
		'chamomilla', 'matricaria', 'jasminum', 'litsea', 'ocimum', 'foeniculum', 'eugenia', 'syzygium',
		'cinnamomum', 'zingiber', 'elettaria', 'illicium', 'pimpinella', 'myrtus', 'laurus', 'styrax',
		'myroxylon', 'vanilla', 'michelia', 'aniba', 'leptospermum', 'cistus', 'coriandrum', 'daucus',
		'helichrysum', 'ylang', 'neroli', 'bergamia', 'cymbopogon', 'lippia', 'tagetes', 'achillea', 'artemisia'];
	// Dragerolie uit zaad, pit, noot of vrucht ruikt doorgaans niet; die slaan we over (behalve wortelzaad en koriander).
	var DRAGER = /\b(seed|kernel|nut|fruit|hip)\s+oil\b/;

	function splits(t) {
		return t.replace(/\n/g, ',').replace(/^\s*(ingredi[eë]nts?|ingredi[eë]nten|inci)\s*:/i, '')
			.split(/[,;•·]|\s\.\s/).map(function (s) { return s.replace(/[*.]+$/, '').trim(); })
			.filter(function (s) { return s.length > 1; });
	}

	function beoordeel(naam) {
		var n = naam.toLowerCase().replace(/\s+/g, ' ');
		var kaal = n.replace(/\([^)]*\)/g, ' ').replace(/\s+/g, ' ').trim();
		if (PARFUM.some(function (p) { return kaal === p || kaal.indexOf(p + ' ') === 0 || kaal.indexOf('/' + p) > -1 || kaal.indexOf(p + '/') > -1; })) {
			return { soort: 'parfum', uitleg: 'Toegevoegde geur. Achter dit ene woord kunnen tientallen stoffen zitten.' };
		}
		for (var i = 0; i < STOFFEN.length; i++) {
			if (kaal.indexOf(STOFFEN[i][0]) > -1) {
				return STOFFEN[i][1]
					? { soort: 'misschien', uitleg: 'Geurstof die ook een andere functie kan hebben, bijvoorbeeld als conserveermiddel of om te verkoelen.' }
					: { soort: 'stof', uitleg: 'Geurstof. Komt vaak uit parfum of uit etherische olie.' };
			}
		}
		var eerste = kaal.split(' ')[0];
		if (GENERA.indexOf(eerste) > -1 && /\boil\b/.test(kaal) && (!DRAGER.test(kaal) || /^(daucus|coriandrum)/.test(kaal))) {
			return { soort: 'olie', uitleg: 'Etherische olie: een geurende plantenolie.' };
		}
		if (GENERA.indexOf(eerste) > -1 && /\b(flower|leaf) water\b|hydrosol/.test(kaal)) {
			return { soort: 'misschien', uitleg: 'Plantenwater van een geurende plant. Ruikt meestal licht.' };
		}
		return null;
	}

	var invoer = root.querySelector('textarea');
	var uit = root.querySelector('.nv-gc-uitkomst');

	function esc(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

	function check() {
		var lijst = splits(invoer.value);
		if (!lijst.length) { uit.hidden = true; return; }
		var gevonden = [];
		lijst.forEach(function (n) { var b = beoordeel(n); if (b) gevonden.push({ naam: n, b: b }); });
		var zeker = gevonden.filter(function (g) { return g.b.soort !== 'misschien'; }).length;
		var html;
		if (!gevonden.length) {
			html = '<p class="nv-gc-kop nv-gc-goed">Geen geurstoffen gevonden in ' + lijst.length + ' ingrediënten.</p>' +
				'<p>We vonden geen parfum, geen etherische olie en geen bekende geurstoffen. Een crème kan dan nog licht naar zijn grondstoffen ruiken, zoals naar een boter of olie.</p>';
		} else {
			html = '<p class="nv-gc-kop">' + (zeker ? zeker + ' van de ' + lijst.length + ' ingrediënten ' + (zeker === 1 ? 'is' : 'zijn') + ' geur.' : 'Twijfelgevallen gevonden.') + '</p><ul class="nv-gc-lijst">' +
				gevonden.map(function (g) {
					return '<li class="nv-gc-' + g.b.soort + '"><strong>' + esc(g.naam) + '</strong><span>' + g.b.uitleg + '</span></li>';
				}).join('') + '</ul>';
		}
		html += '<p class="nv-gc-klein">Deze check zoekt naar parfum, etherische oliën en bekende geurstoffen. Hij is niet volledig en zegt niets over hoe jouw huid reageert. Wat je plakt wordt niet bewaard.' + (window.nevelGcMail ? ' Vraag je de uitslag per mail, dan sturen we alleen de gevonden geurstoffen mee.' : '') + '</p>';
		if (zeker) {
			html += '<div class="nv-gc-nevel"><p>Liever een crème zonder geur? De crèmes van Nevel zijn biologisch en bevatten geen parfum en geen etherische olie.' + (new Date() < new Date('2026-10-18T00:00:00+02:00') ? ' Tot en met 17 oktober met 10% introductiekorting.' : '') + '</p><a class="nv-gc-knop" href="/product/dagcreme/">Bekijk de dagcrème</a> <a href="/product/nachtcreme/">of de nachtcrème</a></div>';
		}
		if (window.nevelGcMail) {
			html += '<form class="nv-gc-mail" novalidate><p class="nv-gc-mail-kop">Uitslag bewaren? We mailen hem je.</p>' +
				'<div class="nv-gc-mail-rij"><input type="email" name="email" placeholder="je@email.nl" autocomplete="email" required><button type="submit">Mail me de uitslag</button></div>' +
				'<label class="nv-gc-mail-tips"><input type="checkbox" name="tips" value="1"> Mail me ook af en toe tips over geurvrije verzorging (afmelden kan altijd)</label>' +
				'<input type="text" name="website" tabindex="-1" autocomplete="off" style="position:absolute;left:-9999px" aria-hidden="true">' +
				'<p class="nv-gc-mail-klein">We gebruiken je e-mailadres alleen hiervoor. Zie de <a href="/privacybeleid-2/">privacyverklaring</a>.</p><p class="nv-gc-mail-melding" aria-live="polite"></p></form>';
		}
		uit.innerHTML = html;
		var form = uit.querySelector('.nv-gc-mail');
		if (form) {
			form.addEventListener('submit', function (e) {
				e.preventDefault();
				var melding = form.querySelector('.nv-gc-mail-melding'), knop = form.querySelector('button');
				var fd = new FormData();
				fd.append('action', 'nevel_gc_mail'); fd.append('n', window.nevelGcMail.nonce);
				fd.append('email', form.email.value); fd.append('tips', form.tips.checked ? '1' : '0');
				fd.append('website', form.website.value); fd.append('aantal', String(lijst.length));
				gevonden.forEach(function (g) { fd.append('gevonden[]', g.naam); });
				knop.disabled = true; melding.textContent = 'Bezig...';
				fetch(window.nevelGcMail.url, { method: 'POST', body: fd, credentials: 'same-origin' })
					.then(function (r) { return r.json(); })
					.then(function (j) { melding.textContent = j.data || (j.success ? 'Verstuurd.' : 'Er ging iets mis.'); if (!j.success) knop.disabled = false; })
					.catch(function () { melding.textContent = 'Er ging iets mis. Probeer het later opnieuw.'; knop.disabled = false; });
			});
		}
		uit.hidden = false;
		uit.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		if (window.fbq) { try { window.fbq('trackCustom', 'Geurcheck', { gevonden: zeker }); } catch (e) {} }
	}

	root.querySelector('.nv-gc-check').addEventListener('click', check);
	root.querySelectorAll('[data-voorbeeld]').forEach(function (k) {
		k.addEventListener('click', function () { invoer.value = k.getAttribute('data-voorbeeld'); check(); });
	});
})();
